import { ApplicationList } from './ui';

export function DashboardPage() {

  return (
    <div className="flex flex-col gap-6">

      <div className="flex flex-col gap-6">
        <h2 className="flex-1 text-2xl font-bold">Заявки</h2>
        <ApplicationList />
      </div>
    </div>
  );
}
